import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierLaneRateTable extends Layout {
    buttonAdd: Button;
    buttonSearch: Button;
    sourceCarrierLaneRate: DataSource;
    tableCarrierLaneRates: Table;
}
